import { useFormContext } from 'react-hook-form';
import { Box } from '@mui/material';
import { FormCheckbox, LwFormDate } from 'redesign';
import { FilterDueDateFormContext } from './filter-due-date.types';

export const FilterDueDate = () => {
  const { watch, control } = useFormContext<FilterDueDateFormContext>();
  const { allowDueDateFilter } = watch();

  return (
    <Box>
      <FormCheckbox
        name="allowDueDateFilter"
        label="Betaaldatum"
        control={control}
        isHeaderCheckbox={true}
      />
      {allowDueDateFilter ? (
        <Box paddingLeft="30px">
          <LwFormDate
            name="dueDate"
            label="Betaaldatum"
            control={control}
            rules={{ required: false }}
            data-testid="due-date"
          />
        </Box>
      ) : null}
    </Box>
  );
};
